import React from "react";
import WorkflowDiagram from "./WorkflowDiagram";

function App() {
  return <WorkflowDiagram />;
}

export default App;
